import Joi from '@hapi/joi'

export const SundryChecklistBPLReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    divisionID: Joi.number().invalid(0).label("Collection Point").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),
    fieldID: Joi.number().label("Field").messages({
    }),
    searchDate: Joi.string().invalid("").label("Search Date"),

    // jobTypeID: Joi.number().invalid(0).required().label("Job Type").messages({
    //     "any.invalid": `Select Job Type`,
    //     "any.required": `Job Type required`
    // }),
}

